import React, { Component } from 'react';
import DataList from 'components/ui/DataList';
import DataPoller from 'components/ui/DataPoller';
import ConfirmModal from 'components/ui/modals/ConfirmModal';
import LocationActionCreators from 'actions/LocationActionCreators';
import LocationStore from 'stores/LocationStore';
import SessionStore from 'stores/SessionStore';
import Roles from 'constants/UserRoles';
import { withTranslation } from 'react-i18next';
import CreateLocationPairModal from './CreateLocationPairModal';

import Mapping from './LocationPairMapping';

const editRoles = [Roles.LOCATIONS_ADMIN, Roles.LOCATIONS_MANAGER, Roles.GOD];
const deleteRoles = [Roles.LOCATIONS_ADMIN, Roles.GOD];

function mapRoles() {
  const roles = SessionStore.getUserRoles();
  const canEdit = roles.some((r) => editRoles.includes(r));
  const canDelete = roles.some((r) => deleteRoles.includes(r));

  return {
    canEdit,
    canDelete,
  };
}

class LocationPairList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errors: {},
      locationPairs: [],
      totalPages: 10,
      filters: {
        page: 1,
        per_page: 25,
        paginate: true,
        sort_by: '_id',
      },
      currentLocationPair: null,
      showConfirmModal: false,
      showCreateLocationPairModal: false,
      ...mapRoles(),
    };
    const { canEdit, canDelete } = this.state;

    this.columnMappings = Mapping.columns.map((col) => {
      if (col.type === 'customActions') {
        return {
          ...col,
          formatExtraData: {
            onEdit: this.handleEdit,
            onDelete: this.handleDelete,
            canEdit,
            canDelete,
          },
        };
      }
      return col;
    });
  }

  componentDidMount() {
    LocationStore.addChangeListener(this.handleLocationStoreChange);
    SessionStore.addChangeListener(this.handleSessionStoreChange);
  }

  componentWillUnmount() {
    LocationStore.removeChangeListener(this.handleLocationStoreChange);
    SessionStore.removeChangeListener(this.handleSessionStoreChange);
  }

  handleLocationStoreChange = () => {
    const locationPairs = LocationStore.getLocationPairs();
    console.log(locationPairs);
    const locationPairsResult = LocationStore.getLocationPairsResult();
    const errors = LocationStore.getLocationPairsError();
    this.setState({
      locationPairs,
      errors,
      totalPages: locationPairsResult?.pages,
    });
  };

  handleSessionStoreChange = () => {
    this.setState(
      {
        ...mapRoles(),
      },
      () => this.handleRolesUpdated,
    );
  };

  handleRolesUpdated = () => {
    const { canEdit, canDelete } = this.state;
    this.columnMappings = Mapping.columns.map((col) => {
      if (col.type === 'customActions') {
        return {
          ...col,
          formatExtraData: {
            onEdit: this.handleEdit,
            onDelete: this.handleDelete,
            canEdit,
            canDelete,
          },
        };
      }
      return col;
    });
  };

  handleAddLocationPair = (e) => {
    e.preventDefault();
    this.setState({
      currentLocationPair: null,
      showCreateLocationPairModal: true,
    });
  };

  handleHideCreateLocationPairModal = () =>
    this.setState({
      currentLocationPair: null,
      showCreateLocationPairModal: false,
    });

  handleSaveLocationPair = (locationPair) => {
    if (!locationPair._id) {
      delete locationPair._id;
      LocationActionCreators.createLocationPair(locationPair);
    } else {
      const id = locationPair._id;
      delete locationPair._id;
      LocationActionCreators.updateLocationPair(id, locationPair);
    }
    this.handleHideCreateLocationPairModal();
  };

  handleConfirmDelete = () => {
    LocationActionCreators.removeLocationPair(
      this.state.currentLocationPair._id,
    );
    this.handleHideConfirmModal();
  };

  handleDelete = (row) => {
    this.setState({
      currentLocationPair: row,
      showConfirmModal: true,
    });
  };

  handleHideConfirmModal = () => {
    this.setState({
      showConfirmModal: false,
      currentLocationPair: null,
    });
  };

  handleEdit = (row) => {
    this.setState({
      currentLocationPair: row,
      showCreateLocationPairModal: true,
    });
  };

  handlePaginationSelect = (page) => {
    let filters;
    this.setState(
      (prevState) => {
        filters = prevState.filters;
        filters.page = page;
        return { filters };
      },
      () => {
        LocationActionCreators.getLocationPairs(filters);
      },
    );
  };

  render() {
    const { t } = this.props;
    return (
      <div className="p-4 mb-4 bg-white rounded shadow wrapper">
        <header className="flex items-center mb-4">
          <h3 className="mt-0 mb-0 mr-2">{t('LOCATION_PAIRS')}</h3>
          {this.state.canEdit && (
            <button
              title={t('CREATE_LOCATION_PAIR')}
              className="flex items-center text-white button button-circle bg-green"
              onClick={this.handleAddLocationPair}
            >
              <i className="mr-0 fa fa-plus" />
            </button>
          )}
        </header>
        <DataPoller
          action={() =>
            LocationActionCreators.getLocationPairs(this.state.filters)
          }
        />
        <DataList
          striped
          showHeaders
          paginate
          data={this.state.locationPairs || []}
          columns={this.columnMappings}
          pages={this.state.totalPages}
          page={this.state.filters.page}
          onPaginationSelect={this.handlePaginationSelect}
        />
        <CreateLocationPairModal
          show={this.state.showCreateLocationPairModal}
          locationPair={this.state.currentLocationPair}
          onHide={this.handleHideCreateLocationPairModal}
          onSave={this.handleSaveLocationPair}
        />
        <ConfirmModal
          show={this.state.showConfirmModal}
          title={t('DELETE_CONFIRMATION')}
          message={t('DELETE_LOCATION_PAIR_CONFIRMATION')}
          onConfirm={this.handleConfirmDelete}
          onHide={this.handleHideConfirmModal}
        />
      </div>
    );
  }
}

export default withTranslation()(LocationPairList);
